export default {
    cash: 'Cash deal',
    financing: 'Financement',
    leasing: 'Location',
};
